import { t } from 'lib/translations/i18next'

export const DEFAULT_ERROR_TEXT = t('somethingWentWrong')
export const CONNECTION_ERROR_TEXT = t('connectionFailedTryAgain')
